import React, { useState } from 'react';
import { Select, Button, Space, message } from 'antd';
import { useEffect } from 'react';
import { useUpdateClientAcl } from '../../hooks/useUserAclComponent';
import CommonTable from '../../commonComponents/Table/table';

const EditAclComponent = props => {
    const [isCompanyList, setIsCompanyList] = useState(false);
    const [companyCodeText, setCompanyCodeText] = useState('');
    const [componentListing, setComponentListing] = useState([]);

    const onGetSuccessAclComponent = async resp => {
        if (resp.status === 200) {
            props.setIsModalComponentAcl(false);
            await props.fetchUserListing();
            message.success('Updated Successfully');
        }
    };
    const { mutate: updateClientAcl } = useUpdateClientAcl(onGetSuccessAclComponent);

    useEffect(() => {
        if (props?.data) {
            setComponentListing(props?.listDesignation);
        }
    }, []);

    const handleRemoveAclComponent = id => {
        let items = [...componentListing];
        let filteredItems = items?.filter(item => item !== id.data);
        setComponentListing(filteredItems);
        // message.success('Successfully Deleted');
    };

    const addDataToAClComponent = data => {
        console.log(data, 'data');
        if (componentListing?.includes(data)) {
            message.info('Already added');
        } else {
            setComponentListing([...componentListing, data]);
            // message.success('Added Successfully');
        }
    };

    console.log(componentListing, 'componentListing', props);

    const updateAclComponent = () => {
        let payload = {
            aclType: 'components',
            updateData: componentListing,
            targetUserId: props?.targetId,
        };
        updateClientAcl(payload);
    };

    const InnerTableCols = [
        {
            title: 'Component Name',
            dataIndex: 'data',
            key: 'data',
        },
        {
            title: 'Action',
            key: 'key',
            render: (_, record) => (
                <Space size="middle">
                    <Button onClick={() => handleRemoveAclComponent(record)} type="primary" danger>
                        Delete
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <>
            <div className="form-table">
                <div>
                    <CommonTable
                        columns={InnerTableCols}
                        data={componentListing?.map((item, index) => ({ id: index, data: item }))}
                        bordered
                        height={'calc(100vh - 463px)'}
                        overflow={'auto'}
                    />
                </div>
            </div>
            {isCompanyList && (
                <Select showSearch placeholder="Select company code" value={companyCodeText} className="select-parent">
                    {props?.data?.components
                        ?.filter(item => !componentListing?.includes(item))
                        .map(el => {
                            return (
                                <Select.Option key={el._id} value={el.code}>
                                    <div onClick={() => addDataToAClComponent(el)}>
                                        <span>{el}</span>
                                    </div>
                                </Select.Option>
                            );
                        })}
                </Select>
            )}
            <div className="p-2">
                <Button style={{ width: 100, marginTop: '1rem' }} onClick={() => setIsCompanyList(true)}>
                    + Add more
                </Button>
            </div>
            <div className="table-footer">
                <Button type="primary" style={{ width: 100 }} onClick={() => updateAclComponent()}>
                    Update
                </Button>
                <Button type="default" onClick={() => props.setIsModalComponentAcl(false)}>
                    Cancel
                </Button>
            </div>
        </>
    );
};

export default EditAclComponent;
